(function () {
  const LOADER_SCRIPT = document.currentScript;
  const MAIN_SCRIPT_URL = LOADER_SCRIPT?.dataset.nvdMain;
  const ASSET_SCRIPT_URL =
    'https://d10pwglna6up6p.cloudfront.net/navidium-widgets/js/nvd-js-asset.js';
  const OVERRIDES_CSS_URL = LOADER_SCRIPT?.dataset.nvdOverrides;

  let loadPromise = null;
  let nvdInitTimer = null;

  function injectNvdToCart() {
    if (document.querySelector('.cd-cart-footer-inner .nvd-mini')) return;

    const target = document.querySelector('.cd-cart-subtotal');
    if (!target) return;

    const mount = document.createElement('div');
    mount.setAttribute('class', 'nvd-mini');
    target.parentNode.insertBefore(mount, target);
  }

  function scheduleNvdInit(delay) {
    if (typeof nvd_init !== 'function') return;

    clearTimeout(nvdInitTimer);
    nvdInitTimer = setTimeout(() => {
      nvd_init();
    }, delay ?? 300);
  }

  function loadStylesheet(href) {
    if (!href || document.querySelector(`link[data-nvd-overrides="true"]`)) return;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.media = 'all';
    link.dataset.nvdOverrides = 'true';
    document.head.appendChild(link);
  }

  function loadScript(src, defer) {
    return new Promise((resolve, reject) => {
      if (document.querySelector(`script[data-nvd-src="${src}"]`)) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = src;
      script.dataset.nvdSrc = src;
      if (defer) script.defer = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`Failed to load ${src}`));
      document.head.appendChild(script);
    });
  }

  function cartDrawerIsOpen() {
    const dawnDrawer = document.querySelector('cart-drawer');
    if (dawnDrawer?.classList.contains('active')) return true;

    const cartixCart = document.querySelector('.cd-cart');
    return Boolean(cartixCart?.classList.contains('is-open'));
  }

  function onCartReady() {
    injectNvdToCart();
    scheduleNvdInit(400);
  }

  window.loadNavidium = function loadNavidium() {
    if (!MAIN_SCRIPT_URL) return Promise.resolve();

    if (loadPromise) return loadPromise;

    loadPromise = (async () => {
      loadStylesheet(OVERRIDES_CSS_URL);
      await loadScript(ASSET_SCRIPT_URL, true);
      await loadScript(MAIN_SCRIPT_URL, true);

      if (cartDrawerIsOpen()) onCartReady();
    })().catch((error) => {
      loadPromise = null;
      console.error('Navidium failed to load', error);
    });

    return loadPromise;
  };

  function handleCartInteraction() {
    window.loadNavidium();
  }

  function bindCartDrawerHooks() {
    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (cartIcon) {
      cartIcon.addEventListener('mouseenter', handleCartInteraction, { once: true });
      cartIcon.addEventListener('focus', handleCartInteraction, { once: true });
      cartIcon.addEventListener('touchstart', handleCartInteraction, { once: true, passive: true });
    }

    document.addEventListener('everyman:cart-open', () => {
      window.loadNavidium()?.then(() => onCartReady());
    });
  }

  function bindCartUpdateHooks() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        window.loadNavidium()?.then(() => scheduleNvdInit(500));
      });
    }

    window.addEventListener('nvd_cart_changed', (event) => {
      if (event.detail?.added?.length || event.detail?.removed?.length) {
        window.loadNavidium()?.then(() => scheduleNvdInit(500));
      }
    });
  }

  function observeCartixDrawer() {
    const attachObserver = (cart) => {
      const observer = new MutationObserver(() => {
        if (cart.classList.contains('is-open')) {
          window.loadNavidium()?.then(() => onCartReady());
        }
      });
      observer.observe(cart, { attributes: true, attributeFilter: ['class'] });
    };

    const existingCart = document.querySelector('.cd-cart');
    if (existingCart) {
      attachObserver(existingCart);
      return;
    }

    const root = document.documentElement;
    const bootObserver = new MutationObserver(() => {
      const cart = document.querySelector('.cd-cart');
      if (!cart) return;
      attachObserver(cart);
      bootObserver.disconnect();
    });
    bootObserver.observe(root, { childList: true, subtree: true });
  }

  window.addEventListener('pageshow', (event) => {
    if (event.persisted && typeof nvd_init === 'function') {
      scheduleNvdInit(0);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      bindCartDrawerHooks();
      bindCartUpdateHooks();
      observeCartixDrawer();
      if (cartDrawerIsOpen()) handleCartInteraction();
    });
  } else {
    bindCartDrawerHooks();
    bindCartUpdateHooks();
    observeCartixDrawer();
    if (cartDrawerIsOpen()) handleCartInteraction();
  }
})();
